//import { Counter } from '../../features/counter/Counter'

export { Page }

export const documentProps = {
  title: 'UI Pilot - About',
  description: 'Chat-based AI code generator that creates forms using Material UI. About page that describes the project.'
}


function Page() {
  return (
    <div style={{ padding: '10px' }}>
      <h1>About</h1>
      <p>UI Pilot is a chat-based AI code generator that creates forms using Material UI, using OpenAI's GPT-3.5 large language model.</p>

      <h2>Features</h2>
      <ul>
        <li>Generates Material UI code for quick prototyping.</li>
        <li>Contextual - you can ask it to make changes to the code it just generated.</li>
        <li>You can make your own changes to the generated code.</li>
      </ul>

      <h2>Details</h2>
      <p>
        Author: Antun Karlovac <a href="https://www.antunkarlovac.com" target="_blank">https://www.antunkarlovac.com</a><br />
        Version: {APP_VERSION}<br />
        Last Updated: {BUILD_TIMESTAMP}<br />
      </p>

    </div>
  )
}
